exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-overlay {\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: -5000;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0; }\n\n.loading-container {\n  background-color: #fff;\n  border-radius: 3px;\n  width: 168px;\n  height: 184px;\n  padding: 32px 0 0 23px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  opacity: 1; }\n\n.loading-icon {\n  background: url(/assets/loading.png) no-repeat center;\n  background-size: 80%;\n  height: 120px;\n  width: 120px;\n  background-size: cover;\n  animation: rotationAnimation;\n  animation-duration: 1s;\n  animation-timing-function: linear;\n  animation-iteration-count: infinite; }\n\n@keyframes rotationAnimation {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(359deg); } }\n\n.active {\n  z-index: 5000; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/loader/loader.component.scss
// module id = ../../../../../src/app/shared/components/loader/loader.component.scss
// module chunks = 12